import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { JobsOffer } from '../../models/jobs-offer';
import { CandidateService } from '../../services/candidate.service';
import { InviteService } from '../../services/invite.service';
import { ApplicantFilter } from '../../interfaces/filters';
import { Constants } from '../constants';

@Injectable()
export class KanbanOfferContractStore implements OnDestroy {
  private _offers: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private _page: BehaviorSubject<number> = new BehaviorSubject(1);
  private _total: BehaviorSubject<number> = new BehaviorSubject(0);
  private _loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _lastPage: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private page: number;
  private total: number;
  private filter:ApplicantFilter;
  private pagecount: number;
  private status: any[];
  private required: boolean;
  private applied: boolean;
  private result: any;
  private load: boolean;
  private suscription: any;
  private job: any;
  public status_name: String;
  public status_ID: number;
  public status_custom: boolean;
  public status_require =  true;

  public STATUS = Constants;

  constructor(private candidateBackendService: CandidateService) {
    //this.loadInitialData(1);
  }

  ngOnDestroy(){
    this._offers.unsubscribe();
  }

  get offers() {
    return this._offers.asObservable();
  }

  get offersNonObservable() {
    this._offers.subscribe(result => this.result = result) ;
    return this.result;
  }

  get currentPage() {
    return this._page.asObservable();
  }

  get getTotal() {
    return this._total.asObservable();
  }

  get loading() {
    return this._loading.asObservable();
  }

  get loadingNonObservable() {
    this._loading.subscribe(result => this.load = result) ;
    return this.load;
  }

  get lastPage() {
    return this._lastPage.asObservable();
  }

  restore(){
    this._offers = new BehaviorSubject([]);
    this._page = new BehaviorSubject(1);
    this._total = new BehaviorSubject(0);
    this._loading = new BehaviorSubject(false);
    this._lastPage = new BehaviorSubject(false);
  }
  statusName(name){
    this.status_name = name;
  }

  statusID(status_id){
    this.status_ID = status_id;
  }

  statusRequire(require){
    this.status_require = require;
  }
  statusCustom(custom){
    this.status_custom = custom;
  }

  changeFilters(status: any, page: number, pagecount?: number, jobId?: string, applied?:boolean, required?:boolean) {
    this.job = jobId;
    this.pagecount = pagecount;
    this._loading.next(true);
    this.status = status;
    this.required = required;
    this.applied = applied;
    this._offers.next([]);
    this.suscription = this.candidateBackendService.getCandidatesContract(this.status, page, pagecount, jobId, required)
      .subscribe(
        res => {
          this.required = required;
          this.applied = applied;
          this.page = page;
          this._page.next(page);
          let applicants:any = res.applicants;
          let list = [];
          applicants.forEach(element => {
            element.firstname = element.user.firstname;
            element.lastname = element.user.lastname;
            element.photo = element.user.photo;
            element.user_id = element.user.id;
            element.email = element.user.email;
            if(this.applied){
              if (element.status_invited >= Constants.STATUS_POSTULED || element.status_invited === false) {
                list.push(element);
              }
            }else{
              list.push(element);
            }
          });
          this._offers.next(list);
          this.total = list.length;
          this._total.next(this.total);
          this._loading.next(false);
          this._lastPage.next(this.page >= this.maxPages());
        },
        () => {
          console.log("Error retrieving Jobs");
          this._loading.next(false);
        }
      );
  }

  refresh(){
    let page = 1;
    this._offers.next([]);
    this.suscription = this.candidateBackendService.getCandidatesContract(this.status, page, this.pagecount, this.job, this.status_require)
      .subscribe(
        res => {
          this.required = this.required;
          this.applied = this.applied;
          this.page = page;
          this._page.next(page);
          let applicants:any = res.applicants;
          let list = [];
          applicants.forEach(element => {
            element.firstname = element.user.firstname;
            element.lastname = element.user.lastname;
            element.photo = element.user.photo;
            element.user_id = element.user.id;
            element.email = element.user.email;
            if(this.applied){
              if (element.status_invited >= Constants.STATUS_POSTULED || element.status_invited === false) {
                list.push(element);
              }
            }else{
              list.push(element);
            }
          });
          this._offers.next(list);
          this.total = list.length;
          this._total.next(this.total);
          this._loading.next(false);
          this._lastPage.next(this.page >= this.maxPages());
        },
        () => {
          console.log("Error retrieving Jobs");
          this._loading.next(false);
        }
      );
  }

  private maxPages() {
    return Math.ceil(this.total / (this.pagecount || 100));
  }

  nextPage(jobInvited) {
    if(this.page < this.maxPages()) {
      if(this.applied){
        this.changeFilters(this.status, this.page + 1, this.pagecount, jobInvited, this.applied, this.required);
      }else{
        this.changeFilters(this.status, this.page + 1, this.pagecount, jobInvited, this.applied, this.required);
      }
    }
  }

  prevPage(jobInvited) {
    if(this.page > 1) {
      if(this.applied){
        this.changeFilters(this.status, this.page + 1, this.pagecount, jobInvited, this.applied, this.required);
      }else{
        this.changeFilters(this.status, this.page + 1, this.pagecount, jobInvited, this.applied, this.required);
      }
    }
  }

  startPage(jobInvited) {
        this.changeFilters(this.status, 1, this.pagecount, jobInvited, this.applied, this.required);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/state/kanban-offer-contract.store.ts